(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    // Assign a unique _order_uid to each form submission so Shopify never merges
// two separate service orders (even if same variant + same property value).
// Each Add to Cart = distinct line item.
document.querySelectorAll('[data-type="add-to-cart-form"]').forEach(function(form) {
  form.addEventListener('submit', function() {
    var uid = form.querySelector('.js-order-uid');
    if (uid) {
      uid.value = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    }
  }, true);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    // Instant price update on variant change, before fetch completes
document.addEventListener('change', function (e) {
  var input = e.target;
  if (!(input instanceof HTMLInputElement) || !input.dataset.priceFormatted) return;

  var picker = input.closest('variant-picker');
  if (!picker) return;

  var section = picker.closest('.shopify-section');
  if (!section) return;

  var saleEl = section.querySelector('product-price .price .money');
  var compareEl = section.querySelector('product-price .compare-at-price .money');

  if (saleEl) saleEl.textContent = input.dataset.priceFormatted;
  if (compareEl && input.dataset.comparePriceFormatted) {
    compareEl.textContent = input.dataset.comparePriceFormatted;
  }
});
  } catch(e) { console.error(e); }
})();

})();
